import { render, staticRenderFns } from "./squareColor.vue?vue&type=template&id=0261afca&scoped=true"
import script from "./squareColor.vue?vue&type=script&lang=js"
export * from "./squareColor.vue?vue&type=script&lang=js"
import style0 from "./squareColor.vue?vue&type=style&index=0&id=0261afca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261afca",
  null
  
)

export default component.exports